import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppMessageService } from '../../../_services/app.message/app.message.service';
import { AppMessage } from '../../../_services/app.message/app.message.model';
import { AppMessageType } from '../../../_services/app.message/app.message.type';
import { Router } from '@angular/router';

@Component({
  selector: 'reuse-fale-conosco',
  templateUrl: './fale-conosco.component.html',
  styleUrls: ['./fale-conosco.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaleConoscoComponent implements OnInit {

  constructor(
    private appMessageService: AppMessageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.criarBreadcrumb();
  }

  goFaq() {
    this.router.navigate(['/faq']);
  }

  /**
   * Configuração da barra 'Breadcrumb'.
   */
  private criarBreadcrumb():void {
    let breadcrumbItems = [
      {icon:'fa fa-phone', label:'Fale Conosco', command: (onclick)=>{this.router.navigate(['fale'])}}
    ];
    this.appMessageService.sendMessage(new AppMessage(AppMessageType.BREADCRUMB, breadcrumbItems));
  }

}
